import { useEffect } from 'react'

// @ts-ignore
import MUSEO_300_WOFF2 from 'Assets/fonts/museoSans/MuseoSans-300.woff2'
// @ts-ignore
import MUSEO_500_WOFF2 from 'Assets/fonts/museoSans/MuseoSans-500.woff2'
// @ts-ignore
import MUSEO_700_WOFF2 from 'Assets/fonts/museoSans/MuseoSans-700.woff2'
// @ts-ignore
import MUSEO_900_WOFF2 from 'Assets/fonts/museoSans/MuseoSans-900.woff2'

const fontFaceRules = `
  @font-face {
    font-family: "MuseoSans";
    font-style: normal;
    font-weight: 300;
    src: url('${MUSEO_300_WOFF2}') format('woff2');
  }
  @font-face {
    font-family: "MuseoSans";
    font-style: normal;
    font-weight: 500;
    src: url('${MUSEO_500_WOFF2}') format('woff2');
  }
  @font-face {
    font-family: "MuseoSans";
    font-style: normal;
    font-weight: 700;
    src: url('${MUSEO_700_WOFF2}') format('woff2');
  }
  @font-face {
    font-family: "MuseoSans";
    font-style: normal;
    font-weight: 900;
    src: url('${MUSEO_900_WOFF2}') format('woff2');
  }
`

const FontFace = () => {
  useEffect(() => {
    const style = document.createElement('style')
    style.textContent = fontFaceRules
    document.head.appendChild(style)
    return () => {
      document.head.removeChild(style)
    }
  }, [])

  return null
}

export default FontFace
